import ContactStyle from "../styles&pics/ContactStyle";
import { useState } from "react";
import CommentForm from "../Forms/CommentForm"
import CommentList from "./CommentList"
export const Contact = () => {
  const [commentChange, setCommentChange] = useState(false);
  

  const handleCommentSubmit = () => {
    setCommentChange(prevState => !prevState);
  };

  return (
    <>
      <ContactStyle />
      <main className="contact-main">
        <div className="contact-container">
          <div className="contact-header">
            <h2>Επικοινωνία</h2>
          </div>

          <div className="contact-info-card">
            <p className="contact-text">
              Για οποιαδήποτε απορία, αναφορά bug ή άλλο λόγο επικοινωνίας:
            </p>
            <a href="mailto:info.jpatch@gmail.com" className="email-link">
              📧 info.jpatch@gmail.com
            </a>
            <p className="contact-text">ή αφήστε ένα σχόλιο παρακάτω!</p>
          </div>

          <div className="forms-section">
            <CommentForm onCommentSubmit={handleCommentSubmit} />
            <CommentList commentChange={commentChange} />
          </div>
        </div>
      </main>
    </>
  )
}

export default Contact